import {
  createSubscription,
  initiateTrial,
  updateTrialDetails,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function trialSignUp(first_name, last_name, email, password) {
  return apiClient.create(initiateTrial, {
    first_name,
    last_name,
    email,
    password,
  });
}

export function createTrialSubscription(data) {
  return apiClient.create(createSubscription, data);
}

export function updateTrialData(data) {
  return apiClient.overwrite(updateTrialDetails, data, true);
}
